import {
  Copy,
  Copyright,
  FlexBox,
  FooterLinksOuter,
  FormBox,
  LandingImage,
  LoginBoxRight,
  LoginContainer,
  LoginFlex,
  LoginFooter,
  LoginImg,
  LoginWrapper,
  LogoImage,
} from "../styled/auth";

import LoginThemeImg from "../assets/images/login-image.jpg";
import Logo from "../assets/images/logo.PNG";
import React from "react";
import { TitleH } from "../styled";
import ResetPasswordForm from "../components/ResetPassword/Form";
import FooterLink from "../components/Auth/FooterLink";

function ResetPassword() {
  return (
    <LoginWrapper>
      <LoginFlex>
        <LoginContainer>
          <FlexBox>
            <LoginImg>
              <a href="/home" className="mob-only">
                <LandingImage src={Logo} alt="Testamentsvollstreckung" />
              </a>
              <img src={LoginThemeImg} alt="Login" />
            </LoginImg>
            <LoginBoxRight>
              <LogoImage>
                <a href="/home" className="mob-hide">
                  <LandingImage src={Logo} alt="Testamentsvollstreckung" />
                </a>
              </LogoImage>
              <TitleH>Passwort Zurücksetzen</TitleH>
              <Copy>
                Bitte geben Sie den Einmal-Code ein, den Sie per E-Mail erhalten haben sowie Ihr neues Passwort und bestätigen Sie dieses,
                um Ihr Passwort zurückzusetzen.
              </Copy>
              <ResetPasswordForm />
              <FormBox />
            </LoginBoxRight>
          </FlexBox>
        </LoginContainer>
        <LoginFooter>
          <Copyright>&copy; Copyright Protevos. Alle Rechte vorbehalten.</Copyright>
          <FooterLinksOuter>
            <FooterLink target="_blank" href="https://innovation-wist.de/agb.html" title="AGB" children="AGB" />
            <FooterLink
              target="_blank"
              href="https://protevos.de/impressum.html"
              title="Datenschutz und Impressum"
              children="Datenschutz und Impressum"
            />
          </FooterLinksOuter>
        </LoginFooter>
      </LoginFlex>
    </LoginWrapper>
  );
}
export default ResetPassword;
